import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const COLOR = "#ffffff";

const SignOut = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 18 14">
    <path
      d="M10.4 13.1C9.4 13.7 8.2 14 7 14C3.1 14 0 10.9 0 7C0 3.1 3.1 0 7 0C8.2 0 9.4 0.3 10.4 0.9L9.1 2.5C8.5 2.2 7.8 2 7 2C4.2 2 2 4.2 2 7C2 9.8 4.2 12 7 12C7.8 12 8.5 11.8 9.1 11.5L10.4 13.1ZM14.9 4H12.3L14.4 6H8C7.4 6 7 6.4 7 7C7 7.6 7.4 8 8 8H14.4L12.3 10H14.9L18 7L14.9 4Z"
      fill={COLOR}
    />
  </SvgIcon>
);
SignOut.displayName = "SignOut";
SignOut.muiName = "SvgIcon";

export default pure(SignOut);
